var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4526_1083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 6.49874C5.21371 6.78575 5.48761 7.02323 5.80215 7.19508C6.11669 7.36693 6.46451 7.46912 6.82201 7.49472C7.17952 7.52032 7.53835 7.46874 7.87417 7.34347C8.20999 7.2182 8.51494 7.02218 8.76833 6.76869L10.2681 5.26896C10.7234 4.79754 10.9753 4.16615 10.9696 3.51078C10.9639 2.85541 10.701 2.22849 10.2376 1.76506C9.77417 1.30162 9.14726 1.03875 8.49189 1.03305C7.83651 1.02736 7.20512 1.2793 6.73371 1.73461L5.87386 2.58945",
    stroke: "#6A7282",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99876 5.49895C6.78407 5.21194 6.51017 4.97446 6.19563 4.80261C5.88109 4.63076 5.53328 4.52857 5.17577 4.50297C4.81826 4.47736 4.45943 4.52895 4.12362 4.65422C3.7878 4.77949 3.48285 4.97551 3.22945 5.229L1.72973 6.72873C1.27442 7.20015 1.02248 7.83154 1.02817 8.48691C1.03387 9.14228 1.29674 9.7692 1.76018 10.2326C2.22361 10.6961 2.85053 10.9589 3.5059 10.9646C4.16127 10.9703 4.79266 10.7184 5.26408 10.2631L6.11892 9.40824",
    stroke: "#6A7282",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4526_1083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9978,
    height: 11.9978,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkicon);
export default __webpack_public_path__ + "static/media/Linkicon.dd6fe7b2d7aead281cb4d5bb5f82ceb4.svg";
export { ForwardRef as ReactComponent };